import React from "react";
import { Typewriter } from "react-simple-typewriter";
import Home from "../../../../common/assets/data/home";
import Container from "../../../utility/ui-components/container";
import Section from "../../../utility/ui-components/section";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

function BannerSection() {
  const data = Home.BannerSection;
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 1,
    },
    desktop: {
      breakpoint: { max: 1920, min: 1024 },
      items: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  return (
    <Section className="bg-primary banner-wave">
      <Container>
        <div class="px-1 md:px-12 mx-auto max-w-7xl">
          <div class="w-full mx-auto text-left md:w-11/12 xl:w-9/12 md:text-center">
            <h1 class="mb-8 text-4xl font-bold leading-none tracking-normal text-white md:text-7xl md:tracking-tight">
              <Typewriter
                words={["Manage", "Monitor", "Control"]}
                loop={true}
                cursor
                cursorStyle="_"
                typeSpeed={70}
                deleteSpeed={50}
                delaySpeed={1000}
              />{" "}
              <span className="text-white">Your Hospital</span>
            </h1>
            {data.paragraph &&
              data.paragraph.map((items, index) => (
                <p
                  key={index + 1}
                  class=" mb-1  px-1 md:mb-8 text-lg text-white capitalize md:text-xl lg:px-24"
                >
                  {items}
                </p>
              ))}

            {/* <div class="mb-4 space-x-0 md:space-x-2 md:mb-8 data-notAvailable">
              {data.buttons.map((button, index) => (
                <Button key={index + 1} button={button} />
              ))}
            </div> */}
          </div>
          <div class="w-full mx-auto mt-20 text-center md:w-10/12">
            <div class="relative z-0 w-full mt-8">
              <div class="relative overflow-hidden shadow-2xl bg-[url('../src/common/assets/images/banner/967shots_so.jpg')]">
                {/* <div class="flex items-center flex-none px-4 bg-green-400 rounded-b-none h-11 rounded-xl">
                  <div class="flex space-x-1.5">
                    <div class="w-3 h-3 border-2 border-white rounded-full"></div>
                    <div class="w-3 h-3 border-2 border-white rounded-full"></div>
                    <div class="w-3 h-3 border-2 border-white rounded-full"></div>
                  </div>
                </div> */}
                 <Carousel
                    responsive={responsive}
                    autoPlay={true}
                    autoPlaySpeed={3000}
                    arrows={false}
                    showDots={false}
                    rewind={true}
                    infinite
                  >
                    {data.BannerImages.map((items,index)=>(
                      <div key={index+1} className="p-[10px]">
                           <img  className="blur-[1px]" src={items.bannerImage} />
                      </div>
                    ))}
                 
                  </Carousel>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </Section>
  );
}

export default BannerSection;
